<template>
  <div class="animated fadeIn">
    <b-card
      header="Catalog tree"
      border-variant="info"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <div slot="header">
        <span data-font="22">Setup</span>
      </div>
      <b-row>
        <!-- <b-col class="md-4">
          <b-card style="width:300px">
         <v-card-text>
                <v-treeview :items="items" :search="search" :open.sync="open"></v-treeview>
              </v-card-text>
           
          </b-card>
        </b-col>-->
        <b-col class="md-12">
          <!-- <b-card  style="width:1200px"> -->
          <faqdetails v-if="isfaq"></faqdetails>
          <!-- </b-card> -->
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import faqdetails from "@/components/MasterSetup/FAQ/FAQDetails.vue";
export default {
  name: "Setup",
  components: {
    faqdetails,
  },
  data: () => {
    return {
      isfaq: true,
      items: [
        {
          id: 1,
          name: "SETUP",
          children: [
            {
              id: 2,
              name: "FAQ",
            },
          ],
        },
      ],
      open: [1, 2],
      search: null,
    };
  },
  mounted: async function () {
    this.provider = this.$store.getters["auth/getUserID"];
  },
  computed: {},
};
</script>

<style scoped>
.mymodalclass > div {
  margin-top: 45px !important;
}
.text-center {
  text-align: center !important;
}
[data-font="20"] {
  font-size: 20px;
}
.edit {
  color: #ffffff !important;
}
.bin {
  color: white !important;
}
</style>
<style>
table.table-bordered > tbody > tr {
  /* text-transform: capitalize; */
  text-align: center;
}
table#table-transition-example .flip-list-move {
  transition: transform 1s;
}
</style>
